var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "农产品分类详情",
        okText: "保存",
        cancelText: "取消",
        width: "800px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "编号",
                        prop: "code",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "code", $$v)
                          },
                          expression: "formState.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "是否参与判定标准",
                        prop: "needJudge",
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.formState.needJudge,
                            callback: function ($$v) {
                              _vm.$set(_vm.formState, "needJudge", $$v)
                            },
                            expression: "formState.needJudge",
                          },
                        },
                        [
                          _c("a-radio", { attrs: { value: "是" } }, [
                            _vm._v(" 是 "),
                          ]),
                          _c("a-radio", { attrs: { value: "否" } }, [
                            _vm._v(" 否 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "中文名称",
                        prop: "cn",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.cn,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "cn", $$v)
                          },
                          expression: "formState.cn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "英文名称",
                        prop: "en",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.en,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "en", $$v)
                          },
                          expression: "formState.en",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "拉丁名称",
                        prop: "ld",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.ld,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "ld", $$v)
                          },
                          expression: "formState.ld",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "中文别名",
                        prop: "nick",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.nick,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "nick", $$v)
                          },
                          expression: "formState.nick",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "GEMS编码",
                        prop: "gems",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.gems,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "gems", $$v)
                          },
                          expression: "formState.gems",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "FOODEX_2编码",
                        prop: "foodex2",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.foodex2,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "foodex2", $$v)
                          },
                          expression: "formState.foodex2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "照片",
                        prop: "zhaopian",
                      },
                    },
                    [
                      _c("a-ext-upload", {
                        model: {
                          value: _vm.formState.zhaopian,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "zhaopian", $$v)
                          },
                          expression: "formState.zhaopian",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "描述",
                        prop: "remark",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "remark", $$v)
                          },
                          expression: "formState.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "排序",
                        prop: "orderby",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.orderby,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "orderby", $$v)
                          },
                          expression: "formState.orderby",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "所属行业",
                        prop: "hangye",
                      },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "HangYe" },
                        model: {
                          value: _vm.formState.hangye,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "hangye", $$v)
                          },
                          expression: "formState.hangye",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }